import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import './sdb-composition-user-state.js';

/**
 * Embeddable, read-only composition status of a given user (admin view).
 *
 * Usage from a host application:
 *   <sdb-embedded-composition-user-state
 *       .settings=${{ portalIdentifier, env }}
 *       .user=${oidcUser}
 *       .targetId=${catalogItem.targetId}
 *       .idString=${participant.idString}
 *       small compressed rows-layout>
 *   </sdb-embedded-composition-user-state>
 */
@customElement('sdb-embedded-composition-user-state')
class SdbEmbeddedCompositionUserState extends EmbeddedHost(LitElement) {

    @property({ type: String })
    accessor idString;

    @property({ type: Boolean })
    accessor light = false;

    @property({ type: Boolean })
    accessor small = false;

    @property({ type: Boolean })
    accessor compressed = false;

    @property({ type: String })
    accessor noSettings = 'showStatus'; // showAll, showStatus, hideAll

    // Status as rows (label left, value right) instead of the summary columns.
    @property({ type: Boolean, attribute: 'rows-layout' })
    accessor rowsLayout = false;

    isReady(state) {
        return super.isReady(state) && !!this.compositionId && !!this.idString;
    }

    render() {
        if (!this.ready) {
            return nothing;
        }

        return html`
            <sdb-composition-user-state
                compositionId=${this.compositionId}
                idString=${this.idString}
                noSettings=${this.noSettings}
                ?light=${this.light}
                ?small=${this.small}
                ?compressed=${this.compressed}
                ?rows-layout=${this.rowsLayout}>
            </sdb-composition-user-state>
        `;
    }
}
